const asObject = (value) =>
  value && typeof value === "object" && !Array.isArray(value) ? value : {};

const compact = (value) => String(value || "").trim();

export const SUPPORTED_SPORTS_CARD_VARIANTS = new Set([
  "player_card",
  "team_card",
  "team_v_team",
  "scoring_summary",
]);

export const sportsCardPayloadForMessage = (message) => {
  const payload =
    message?.sportsCardData ||
    message?.sports_card_data ||
    null;
  return Object.keys(asObject(payload)).length ? payload : null;
};

export const sportsCardData = (payload) => asObject(asObject(payload).data);

export const sportsCardVariant = (payload) => {
  const row = asObject(payload);
  const data = sportsCardData(row);
  const variant = compact(
    row.variant ||
      row.card_variant ||
      row.cardVariant ||
      data.variant ||
      data.card_variant ||
      data.cardVariant,
  );
  return SUPPORTED_SPORTS_CARD_VARIANTS.has(variant) ? variant : "";
};

export const sportsCardIsRenderable = (payload) =>
  Boolean(sportsCardVariant(payload) && Object.keys(sportsCardData(payload)).length);

export const sportsCardGeneratedAt = (payload) => {
  const row = asObject(payload);
  const data = sportsCardData(row);
  return row.generated_at || row.generatedAt || data.as_of || data.asOf || null;
};

export const sportsCardTitle = (payload) => {
  const row = asObject(payload);
  const data = sportsCardData(row);
  const variant = sportsCardVariant(row);
  const player = asObject(
    row.selected_player || row.selectedPlayer || data.selected_player || data.selectedPlayer,
  );
  const team = asObject(
    row.selected_team || row.selectedTeam || data.selected_team || data.selectedTeam,
  );

  const explicitTitle = compact(
    data.label || data.title || data.matchup || row.title,
  );
  if (explicitTitle) return explicitTitle;

  if (variant === "player_card") {
    return compact(player.full_name || player.name) || "Player profile";
  }
  if (variant === "team_card") {
    return compact(team.name || team.short_name || team.abbreviation) || "Team profile";
  }
  if (variant === "team_v_team") return "Matchup";
  if (variant === "scoring_summary") return "Scoring summary";
  return "Sports evidence";
};

export const sportsCardKindLabel = (payload) => {
  const variant = sportsCardVariant(payload);
  if (variant === "player_card") return "Player profile";
  if (variant === "team_card") return "Team profile";
  if (variant === "team_v_team") return "Matchup";
  if (variant === "scoring_summary") return "Game summary";
  return "Sports evidence";
};

export const sportsCardContextLabel = (payload) => {
  const row = asObject(payload);
  const data = sportsCardData(row);
  const league = asObject(row.league || data.league);
  const leagueLabel = compact(league.abbreviation || league.name);
  const state = compact(row.event_state || row.eventState).replace(/_/g, " ");
  return [leagueLabel, state].filter(Boolean).join(" · ");
};
